export default [
    {
        path: '',
        name: 'cms.dashboard',
        component: () => import(/* webpackChunkName: "cms" */ '@/views/Cms/Dashboard.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: 'users',
        name: 'cms.users',
        component: () => import(/* webpackChunkName: "cms" */ '@/views/Cms/Users/List.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: 'users/:id',
        name: 'cms.users.single',
        params: ':id',
        component: () => import(/* webpackChunkName: "cms" */ '@/views/Cms/Users/Single.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: 'assets',
        name: 'cms.assets',
        component: () => import(/* webpackChunkName: "cms" */ '@/views/Cms/Assets/List.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: 'assets/:id',
        name: 'cms.assets.single',
        params: ':id',
        component: () => import(/* webpackChunkName: "cms" */ '@/views/Cms/Assets/Single.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: 'pages',
        name: 'cms.pages',
        component: () => import(/* webpackChunkName: "cms" */ '@/views/Cms/Pages/List.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: 'pages/:id',
        name: 'cms.pages.single',
        params: ':id',
        component: () => import(/* webpackChunkName: "cms" */ '@/views/Cms/Pages/Single.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: 'categories',
        name: 'cms.categories',
        component: () => import(/* webpackChunkName: "cms" */ '@/views/Cms/Categories/List.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: 'categories/:id',
        name: 'cms.categories.single',
        params: ':id',
        component: () => import(/* webpackChunkName: "cms" */ '@/views/Cms/Categories/Single.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: 'contact-forms',
        name: 'cms.contact-forms',
        component: () => import(/* webpackChunkName: "cms" */ '@/views/Cms/ContactForms/List.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: 'contact-forms/:id',
        name: 'cms.contact-forms.single',
        params: ':id',
        component: () => import(/* webpackChunkName: "cms" */ '@/views/Cms/ContactForms/Single.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: 'settings',
        name: 'cms.settings',
        component: () => import(/* webpackChunkName: "cms" */ '@/views/Cms/Settings/List.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: 'settings/:id',
        name: 'cms.settings.single',
        params: ':id',
        component: () => import(/* webpackChunkName: "cms" */ '@/views/Cms/Settings/Single.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: 'projects',
        name: 'cms.projects',
        component: () => import(/* webpackChunkName: "cms" */ '@/views/Cms/Projects/List.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: 'projects/:id',
        name: 'cms.projects.single',
        params: ':id',
        component: () => import(/* webpackChunkName: "cms" */ '@/views/Cms/Projects/Single.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: 'project-administrator',
        name: 'cms.project-administrator',
        component: () => import(/* webpackChunkName: "cms" */ '@/views/Cms/Administrator/AdministrationProjectSingle.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: 'classes',
        name: 'cms.classes',
        component: () => import(/* webpackChunkName: "cms" */ '@/views/Cms/Pages/FullClasses.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: 'components',
        name: 'cms.components',
        component: () => import(/* webpackChunkName: "cms" */ '@/views/Cms/Pages/Components/List.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: 'components/:id',
        name: 'cms.components.single',
        params: ':id',
        component: () => import(/* webpackChunkName: "cms" */ '@/views/Cms/Pages/Components/Single.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: 'templates',
        name: 'cms.templates',
        component: () => import(/* webpackChunkName: "cms" */ '@/views/Cms/Pages/Templates/List.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: 'templates/:id',
        name: 'cms.templates.single',
        params: ':id',
        component: () => import(/* webpackChunkName: "cms" */ '@/views/Cms/Pages/Templates/Single.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: 'hostess',
        name: 'cms.hostess',
        component: () => import(/* webpackChunkName: "cms" */ '@/views/Cms/Hostess/Hostess.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: 'hostess/contact-forms',
        name: 'cms.hostess.contact-forms',
        params: ':id',
        component: () => import(/* webpackChunkName: "cms" */ '@/views/Cms/Hostess/ContactForms/List.vue'),
        meta: {
            auth: true,
        },
    },
    {
        path: 'hostess/contact-forms/:id',
        name: 'cms.hostess.contact-forms.single',
        params: ':id',
        component: () => import(/* webpackChunkName: "cms" */ '@/views/Cms/Hostess/ContactForms/Single.vue'),
        meta: {
            auth: true,
        },
    },
];